import React from "react";
import SubNavigation from "../SubNavigation";
import AccountSubNavigation from "./AccountSubNavigation";
import AccountIcon from "./AccountIcon";

const AccountNavigation = ({ loading, user, selectMenu, renderSubNav }) => {
  return (
    <>
      <AccountIcon
        loading={loading}
        user={user}
        onUserMenu={() => selectMenu("account")}
      />
      {renderSubNav("account")(
        <SubNavigation appearance="aside" onClose={() => selectMenu(null)}>
          {user && <AccountSubNavigation user={user} />}
        </SubNavigation>
      )}
    </>
  );
};

export default AccountNavigation;
